<div class="container-fluid">
    <div class="row">
        <div class="col-6 d-flex flex-column text-left">
            <h3>
                Guatemaltecos Ilustres
            </h3>
            <h4>
                Derechos reservados {{ currentYear }}
            </h4>
        </div>
        <div class="col-6 d-flex flex-column text-right">
            <div class="row d-flex justify-content-end align-items-center container-items">
                <a [href]="config?.url_instagram" class="buttonslink" style="cursor: pointer;" target="_blank">
                    <img title="Instragram" src="assets/img/icon/in.svg" alt="img">
                </a>
                <a [href]="config?.url_twitter" class="buttonslink" style="cursor: pointer;" target="_blank">
                    <img title="Twitter" src="assets/img/icon/tiktok.jpeg" alt="img">
                </a>
                <a [href]="config?.url_facebook" class="buttonslink" style="cursor: pointer;" target="_blank">
                    <img title="Facebook" src="assets/img/icon/fb.svg" alt="img">
                </a>
                <a href="#" class="logoUniversales">
                    <img title="Universales" src="assets/img/icon/universales.svg" alt="img">
                </a>
            </div>
            <div class="terminos">
                <a href="#/terminos">
                    Términos y Condiciones
                </a>
                <a style="margin-left: 10px;" href="#/politicas">
                    Política de privacidad
                </a>
            </div>
        </div>
    </div>
</div>